import { useEffect, useRef, useState } from "react";
import "./PageHero.css";

const HERO_IMAGES = {
  clases: [
    "https://yvovqpmcbtmafbswcvoa.supabase.co/storage/v1/object/public/assets/Images/Azar.jpg",
    "https://yvovqpmcbtmafbswcvoa.supabase.co/storage/v1/object/public/assets/Images/Estadistica.jpg",
    "https://yvovqpmcbtmafbswcvoa.supabase.co/storage/v1/object/public/assets/Images/estadistica-e1607728657107.jpg",
  ],
  articulos: [
    "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=900&q=80",
    "https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?w=900&q=80",
    "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=900&q=80",
  ],
  recursos: [
    "https://images.unsplash.com/photo-1509062522246-3755977927d7?w=900&q=80",
    "https://images.unsplash.com/photo-1488190211105-8b0e65b80b4e?w=900&q=80",
    "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=900&q=80",
  ],
};

/**
 * PageHero — banner mitad teal / mitad imagen rotante
 *
 * Props:
 *   section  : "clases" | "articulos" | "recursos"
 *   title    : string
 *   backBtn? : { label, onClick }
 *   images?  : string[]  (override)
 */
export default function PageHero({ section = "clases", title, backBtn, images }) {
  const imgs = images || HERO_IMAGES[section] || HERO_IMAGES.clases;
  const [current, setCurrent] = useState(0);
  const [fading,  setFading]  = useState(false);
  const timer = useRef(null);

  const goTo = (idx) => {
    if (idx === current || imgs.length <= 1) return;
    setFading(true);
    setTimeout(() => { setCurrent(idx); setFading(false); }, 380);
  };

  useEffect(() => {
    if (imgs.length <= 1) return;
    timer.current = setInterval(() => goTo((current + 1) % imgs.length), 4500);
    return () => clearInterval(timer.current);
  }, [current, imgs.length]);

  return (
    <div className="ph-root">
      {/* ─── Mitad izquierda: teal ─────────────────────────── */}
      <div className="ph-left">
        {backBtn && (
          <button className="ph-back" onClick={backBtn.onClick}>
            ← {backBtn.label}
          </button>
        )}

        <h1 className="ph-title">{title}</h1>

        {imgs.length > 1 && (
          <div className="ph-dots">
            {imgs.map((_, i) => (
              <button
                key={i}
                className={`ph-dot ${i === current ? "active" : ""}`}
                onClick={() => goTo(i)}
                aria-label={`Imagen ${i + 1}`}
              />
            ))}
          </div>
        )}
      </div>

      {/* ─── Mitad derecha: imagen ─────────────────────────── */}
      <div className="ph-right">
        {imgs.map((src, i) => (
          <div
            key={src}
            className={`ph-img ${i === current ? "visible" : ""} ${i === current && fading ? "fading" : ""}`}
            style={{ backgroundImage: `url(${src})` }}
          />
        ))}
        <div className="ph-vignette" />
      </div>
    </div>
  );
}